import { initialState } from './initialState';
import * as types from './types';

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case types.SET_USER_INFO_TYPE:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload.user,
        },
      };
    case types.SET_IS_AUTHENTICATED_TYPE:
      return {
        ...state,
        isAuthenticated: !!payload.isAuthenticated,
      };
    case types.SET_USER_EMAIL:
      return {
        ...state,
        user: { ...state.user, email: payload.email },
      };
    case types.SET_IS_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: !!payload.isAuthenticated,
      };
    case types.SET_USER_COUPON:
      return {
        ...state,
        user: { ...state.user, coupon: payload.coupon },
      };
    case types.SET_USER_CODE:
      return {
        ...state,
        user: { ...state.user, code: payload.code, source: payload.source },
      };
    case types.CODE_CONFIRM:
      return {
        ...state,
        getVerifyCode: payload.code,
      };
    case types.RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
